import { render, staticRenderFns } from "./lookTemplate.vue?vue&type=template&id=16ff108c&scoped=true"
import script from "./lookTemplate.vue?vue&type=script&lang=js"
export * from "./lookTemplate.vue?vue&type=script&lang=js"
import style0 from "./lookTemplate.vue?vue&type=style&index=0&id=16ff108c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ff108c",
  null
  
)

export default component.exports